// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { ApolloClient, ApolloLink, InMemoryCache, type NormalizedCacheObject } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { clientLogger } from '@seedplanner/logger';
import { LOGGED_OUT_ERROR_MESSAGE } from '@seedplanner/shared-utils';
import { HttpLink } from './HttpLink';

export const createApolloClient = ({
  labels,
  endpoint,
  apolloState,
}: {
  readonly labels: Record<string, string>;
  readonly endpoint: string;
  readonly apolloState: NormalizedCacheObject;
}) => {
  const httpLink = new HttpLink({
    endpoint,
    labels,
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      for (const graphqlError of graphQLErrors) {
        if (graphqlError.message === LOGGED_OUT_ERROR_MESSAGE) {
          return;
        }
        const logInfo = {
          title: 'graphql_apollo_client_graphql_error',
          error: graphqlError.message,
          ...labels,
        };
        clientLogger.error({ ...logInfo });
      }
    }
    if (networkError) {
      const logInfo = {
        title: 'graphql_apollo_client_network_error',
        error: networkError.message,
        ...labels,
      };
      clientLogger.error({ ...logInfo });
    }
  });

  return new ApolloClient({
    // connectToDevTools: false,
    link: ApolloLink.from([errorLink, httpLink]),
    cache: new InMemoryCache().restore(apolloState),
    queryDeduplication: false,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
        notifyOnNetworkStatusChange: false,
      },
      query: {
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
      },
      mutate: {
        errorPolicy: 'none',
      },
    },
  });
};
